<template>
    <header>
        <h3 class="text-xl lg:text-2xl font-medium text-slate-800 mb-2">
            {{ trip.title }}
        </h3>
        <p class="text-slate-500 text-sm">
            {{ startDate(trip.start_date) }}
            <span v-if="trip.end_date">
                -
                {{ endDate(trip.end_date) }}
            </span>
        </p>
    </header>
</template>
<script setup>
import dayjs from 'dayjs';
const props = defineProps({
    trip: Object,
    userTrip: Object,
});

const startDate = (date) => {
    if (props.userTrip) {
        return dayjs(props.userTrip?.start_date).format('MMM DD, YYYY');
    } else {
        return dayjs(date).format('MMM DD, YYYY');
    }
};

const endDate = (date) => {
    if (props.userTrip) {
        return dayjs(props.userTrip?.end_date).format('MMM DD, YYYY');
    } else {
        return dayjs(date).format('MMM DD, YYYY');
    }
};
</script>
